// Utility functions for geocoding and extracting zipcodes using Google Maps API

export const ERROR_MESSAGES = {
	NO_ZIPCODE: 'A zip code could not be determined for this location.',
	FETCH_FAILED: 'Failed to fetch place details'
};

// Helper: Extract zipcode from geocoder results
const extractZipcodeFromResults = (results) => {
	if (!results?.length) return null;

	const postalComponent = results
		.flatMap((result) => result.address_components)
		.find((component) => component.types.includes('postal_code'));

	return postalComponent?.long_name || null;
};

// Helper: Geocode coordinates to get zipcode
export const geocodeLocation = (lat, lng) => {
	return new Promise((resolve, reject) => {
		const geocoder = new window.google.maps.Geocoder();
		const location = { lat, lng };

		geocoder.geocode({ location }, (results, status) => {
			if (status === 'OK') {
				const zipcode = extractZipcodeFromResults(results);
				if (zipcode) {
					resolve(zipcode);
				} else {
					reject(new Error(ERROR_MESSAGES.NO_ZIPCODE));
				}
			} else {
				reject(new Error(ERROR_MESSAGES.NO_ZIPCODE));
			}
		});
	});
};
